import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { toNumber } from 'lodash';
import { firstValueFrom } from 'rxjs';
import { PaymentEntity } from 'src/app/shared';
import { PaymentService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class PaymentResolver
  
{
  constructor(private paymentService: PaymentService) {}

  async resolve(
    route: ActivatedRouteSnapshot
  ): Promise<boolean | PaymentEntity> {
    try {
      const hash =
        route.params['hash'] ||
        route.queryParams['hash'] ||
        route.queryParams['complete'] ||
        route.queryParams['id'] ||
        null;

      if (!hash) {
        return false;
      } else {
        return await firstValueFrom(
          this.paymentService.readByHash(toNumber(hash))
        );
      }
    } catch (err: any) {
      return false;
    }
  }
}
